let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("fVG9a")]).then(() => parcelRequire('by822'));